// Common constants used across the project

// CSS class constants
export const CSS_CLASSES = {
  ROW_MARGIN: "row-margin",
  D_NONE: "d-none",
  FONT_WEIGHT: "fontWeight ms-2",
  MS_2: "ms-2",
  BORDER_RADIO_INPUT: "border radioInput",
  BORDER_RADIO_INPUT_ERROR: "border radioInput error",
  ERROR_HEAD: "error-head",
  ERROR_INPUT: "error-input",
  ERR_INPUT: "err-input"
};

// Style objects
export const STYLE_OBJECTS = {
  errorstyle: {
    control: (baseStyles) => ({
      ...baseStyles,
      borderColor: "red",
    }),
  },
  greenstyle: {
    control: (baseStyles) => ({
      ...baseStyles,
      borderColor: "green",
    }),
  },
  normalstyle: {
    control: (baseStyles) => ({
      ...baseStyles,
      borderColor: "blue",
    }),
  }
};

// Common validation messages
export const COMMON_MESSAGES = {
  ALL_FIELDS_MANDATORY: "All fields are Mandatory",
  ATLEAST_ONE_PROCESS: "Atleast one Process and type is required",
  ATLEAST_ONE_PROCESS_TYPE: "Atleast one Process and Type is required"
};

// Radio button values
export const RADIO_VALUES = {
  REQUIRED: "Required",
  OPTIONAL: "Optional", 
  NONE: "None",
  YES: "Yes",
  NO: "No",
  NA: "NA"
};

// WPS Type constants
export const WPS_TYPES = {
  GROOVE: "Groove",
  OVERLAY: "Overlay",
  TUBESHEET: "Tubesheet"
};

// Common array structure for error objects
export const DEFAULT_ERROR_ITEM = {
  id: "",
  msg: "",
  className: CSS_CLASSES.BORDER_RADIO_INPUT
};

export const ERROR_ITEM_ALL_MANDATORY = {
  id: "all",
  msg: COMMON_MESSAGES.ALL_FIELDS_MANDATORY,
  className: CSS_CLASSES.BORDER_RADIO_INPUT_ERROR
};

// ============================================================================
// VALIDATION AND MESSAGE TYPES (moved from WPSGroove_entity.js)
// ============================================================================

// USED - Imported and used in 20+ files across WPS, WPQ, PQR transactions for validation messaging
export const MessageTypes = {
  Success: "Success",
  Fail: "Failure",
  Required: "Required",
  RequiredAll: "RequiredAll",
  Temp: "Temp",
  Band: "Band",
  None: "None",
  SpecialCharacters: "SpecialCharacters",
  ProcessDeleted: "ProcessDeleted",
  ProcessDeleteFailed: "ProcessDeleteFailed",
  ErrorShown: "ErrorShown", // For cases where specific error is already displayed
  characterserror: "Special Characters # & % + - ' < > = ; not allowed"
};

// ============================================================================
// ACTION AND STATUS TYPES (moved from WPSGroove_entity.js)
// ============================================================================

// USED - Used across WPS, WPQ, PQR transactions for action type identification
export const Action = {
  ActionEdit: "Edit",
  ActionCopy: "Copy",
  ActionAdd: "Add",
};

// USED - Used across WPS, WPQ, PQR transactions for status management
export const Status = {
  StatusPending: "Pending For Approval",
  StatusApproved: "Approved",
  StatusRejected: "Rejected",
  StatusTempSaved: "Temporary Saved",
  StatusFreezed: "Freezed",
};


export const ToastMessages = {
  Temp: "Temporary Saved WPQ Data Successfully",
  Success: "WPQ data added",
  Fail: "Failed, WPQ Data could not be saved",
  Required: "Required Fields not filled ",
  RequiredAll: "Required Fields not filled.Please check and Fill Required Fields for all 3 Pages.",
  Band: "Data Temporary Saved but P and T band welding engineers not present in User Master. Cannot sent for approval",
  None: "",
  ErrorShown: "", // No additional message needed as specific error is already shown
  SpecialCharacters: process.env.REACT_APP_SPECIAL_CHARACTER_MSG
}